import React, { useState, useRef, useEffect } from 'react'
import { IoChevronDown } from 'react-icons/io5'
import { SearchType } from './hooks/useMobileSearchAPI'
import { DropdownMenu, DropdownItem } from './MobileSearch.styles'

interface MobileSearchTypeDropdownProps {
  value: SearchType
  label: string
  onChange: (value: SearchType) => void
  labelPrefix?: string
  options?: { value: SearchType; label: string }[]
}

const SEARCH_OPTIONS: Array<{ value: SearchType; label: string }> = [
  { value: 'fb_company', label: 'First Bite Company' },
  { value: 'fb_location', label: 'First Bite Location' },
  { value: 'custom_company', label: 'Custom Company' },
  { value: 'custom_location', label: 'Custom Location' },
]

export const MobileSearchTypeDropdown: React.FC<
  MobileSearchTypeDropdownProps
> = ({
  value,
  label,
  onChange,
  labelPrefix = 'Search for a',
  options = SEARCH_OPTIONS,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const handleSelect = (newValue: SearchType) => {
    onChange(newValue)
    setIsOpen(false)
  }

  return (
    <div style={{ position: 'relative' }} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-auto px-2 py-1.5 bg-transparent border-0 inline-flex items-center gap-1 text-sm text-fg cursor-pointer mb-2 hover:opacity-70"
      >
        <div>
          <span className="text-fg-secondary text-sm">{labelPrefix} </span>
          <span className="text-fb-green-900 font-medium underline">
            {label}
          </span>
        </div>
        <IoChevronDown size={20} />
      </button>

      {isOpen && (
        <DropdownMenu>
          {options.map((option) => (
            <DropdownItem
              key={option.value}
              type="button"
              $isSelected={option.value === value}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      )}
    </div>
  )
}
